import React, { useEffect, useState } from 'react'
import { Row, Col, Space } from 'antd'
import { PlotMenu } from './components/PlotMenu'
import { MediosChart } from './components/MediosChart'

import 'antd/dist/antd.min.css'
import moment from 'moment'

function App () {
  // States
  const [totalData, setTotalData] = useState({
    datasets: [{ data: [] }, { data: [] }],
    labels: []
  })
  const [chartData, setChartData] = useState({
    datasets: [{ data: [] }, { data: [] }],
    labels: []
  })
  const [medios, setMedios] = useState([])
  const [currentRadio, setCurrentRadio] = useState(['Todas las radios'])
  const [currentMedio, setCurrentMedio] = useState(['Todos los medios'])
  const [radios, setRadios] = useState([])
  const [inicio, setInicio] = useState(0)
  const [final, setFinal] = useState(0)
  const [options, setOptions] = useState({})
  const [aprueboState, setAprueboState] = useState(true)
  const [rechazoState, setRechazoState] = useState(true)

  const [width, setWindowWidth] = useState(0)
  const [resizeVars, setResizeVars] = useState(true)

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
  }

  useEffect(() => {
    const getDatos = async () => {
      // Get data noticias y radios
      /* const currentDate = moment().subtract(1, 'days')
      const weekStart = currentDate.clone().startOf('isoweek')
      const nombreArchivo = `data_${weekStart.format('DD_MM')}.json` */
      const nombreArchivo = 'data_29_08.json'
      let res = await fetch(
        `https://d1uww442kixcfq.cloudfront.net/todosJSON/${nombreArchivo}`
      )

      if (res.status === 403) {
        const currentDate = moment().subtract(8, 'days')
        const weekStart = currentDate.clone().startOf('isoweek')
        const nombreArchivo = `data_${weekStart.format('DD_MM')}.json`
        res = await fetch(
          `https://d1uww442kixcfq.cloudfront.net/todosJSON/${nombreArchivo}`
        )
      }

      const data = await res.json()
      const medios = data.medios
      const radios = data.radios
      const image = new Image()
      image.crossOrigin = 'anonymous' // This enables CORS
      image.src =
        'https://d1uww442kixcfq.cloudfront.net/encuestas/imgs/logo2.png'
      setTotalData(data)
      setFinal(medios.Todos.rechazo.length + 1)

      setOptions({
        responsive: true,
        layout: {
          padding: {
            right: function (ctx) {
              if (ctx.chart.width < 800) {
                return 5
              }
              return 20
            },
            top: function (ctx) {
              if (ctx.chart.width < 800) {
                return 20
              }
              return 40
            }
          }
        },
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            position: 'top',
            align: 'start'
          },
          title: {
            display: false,
            text: 'Apruebo y Rechazo por semana (Total)'
          }
        },
        scales: {
          x: {
            ticks: {
              maxTicksLimit: function (ctx) {
                const widthTicks = ctx.chart.width
                if (widthTicks < 800) {
                  return 10
                } else {
                  return 15
                }
              },
              maxRotation: 0,
              minRotation: 0,
              font: function (context) {
                const widthFont = context.chart.width
                const size = 8 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            },
            grid: {
              display: false,
              drawBorder: true,
              drawOnChartArea: false,
              drawTicks: true,
              borderColor: 'black'
            },
            title: {
              display: true,
              text: 'Semana',
              font: function (context) {
                const widthFont = context.chart.width
                const size = 10 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            }
          },
          y: {
            min: 0,
            max: function (ctx) {
              const valuesArray = ctx.chart.config._config.data.datasets[1].data.map((x) => x.y)
              const max = Math.max(...valuesArray)
              const index = valuesArray.indexOf(max)
              const maxApruebo =
                ctx.chart.config._config.data.datasets[0].data.at(index).y
              const maxRechazo =
                ctx.chart.config._config.data.datasets[1].data.at(index).y
              const maxValue =
                200 *
                (Math.floor(Math.max(...[maxApruebo, maxRechazo]) / 200) + 1)
              return maxValue
            },
            ticks: {
              beginAtZero: true,
              stepSize: 100,
              font: function (context) {
                const widthFont = context.chart.width
                const size = 8 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            },
            grid: {
              display: true,
              drawBorder: true,
              borderColor: 'black'
            },
            title: {
              display: true,
              text: 'Cantidad de noticias (●)',
              font: function (context) {
                const widthFont = context.chart.width
                const size = 10 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            }
          },
          y1: {
            min: 0,
            position: 'right',
            max: function (ctx) {
              const valuesArray = ctx.chart.config._config.data.datasets[3].data.map((x) => x.y)
              const max = Math.max(...valuesArray)
              const index = valuesArray.indexOf(max)
              const maxApruebo =
                ctx.chart.config._config.data.datasets[2].data.at(index).y
              const maxRechazo =
                ctx.chart.config._config.data.datasets[3].data.at(index).y
              const maxValue =
                200 *
                (Math.floor(Math.max(...[maxApruebo, maxRechazo]) / 200) + 1)
              return maxValue
            },
            ticks: {
              callback: function (value, index, ticks) {
                return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
              },
              beginAtZero: true,
              stepSize: 200,
              font: function (context) {
                const widthFont = context.chart.width
                const size = 8 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            },
            grid: {
              drawOnChartArea: false
            },
            title: {
              position: 'left',
              display: true,
              text: 'Cantidad de menciones en radios (▲)',
              font: function (context) {
                const widthFont = context.chart.width
                const size = 10 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            }
          }
        },
        img_decidechile: image
      })

      setChartData({
        labels: medios.Todos.labels,
        datasets: [
          {
            label: 'Apruebo-Medios',
            id: 'medios_apruebo',
            backgroundColor: 'rgba(0, 169, 209, 1)',
            borderColor: 'rgba(0, 169, 209, 1)',
            borderWidth: 3,
            tension: 0.4,
            data: medios.Todos.apruebo,
            pointStyle: 'circle',
            pointRadius: 3,
            pointHoverRadius: 8,
            hidden: false,
            yAxisID: 'y'
          },
          {
            label: 'Rechazo-Medios',
            id: 'medios_rechazo',
            backgroundColor: 'rgba(255, 58, 59, 1)',
            borderColor: 'rgba(255, 58, 59, 1)',
            borderWidth: 3,
            data: medios.Todos.rechazo,
            pointStyle: 'circle',
            pointRadius: 3,
            pointHoverRadius: 8,
            hidden: false,
            tension: 0.4,
            yAxisID: 'y'
          },
          {
            label: 'Apruebo-Radios',
            id: 'radios_apruebo',
            backgroundColor: 'rgba(0, 169, 209, 1)',
            borderColor: 'rgba(0, 169, 209, 1)',
            borderDash: [7, 7],
            borderWidth: 3,
            tension: 0.4,
            data: radios.Todos.apruebo,
            pointStyle: 'triangle',
            pointRadius: 3,
            pointHoverRadius: 8,
            hidden: false,
            yAxisID: 'y1'
          },
          {
            label: 'Rechazo-Radios',
            id: 'radios_rechazo',
            backgroundColor: 'rgba(255, 58, 59, 1)',
            borderColor: 'rgba(255, 58, 59, 1)',
            borderDash: [7, 7],
            borderWidth: 3,
            data: radios.Todos.rechazo,
            pointStyle: 'triangle',
            pointRadius: 3,
            pointHoverRadius: 8,
            hidden: false,
            tension: 0.4,
            yAxisID: 'y1'
          }
        ]
      })

      medios['Todos los medios'] = medios.Todos
      radios['Todas las radios'] = radios.Todos
      delete medios.Todos
      delete radios.Todos

      const mediosArray = Object.keys(medios)
      const mediosMod = [
        mediosArray.find(element => element === 'Todos los medios'),
        ...mediosArray.filter(element => element !== 'Todos los medios')
      ]

      setMedios(mediosMod)

      const radiosArray = Object.keys(radios)
      const radiosMod = [
        radiosArray.find(element => element === 'Todas las radios'),
        ...radiosArray.filter(element => element !== 'Todas las radios')
      ]
      setRadios(radiosMod)
    }
    getDatos()
    updateDimensions()

    window.addEventListener('resize', updateDimensions)

    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  // UseEffect para las legendas apruebo y rechazo
  useEffect(() => {
    if (aprueboState) {
      setChartData(c => {
        return {
          ...c,
          datasets: [
            {
              ...c.datasets[0],
              backgroundColor: 'rgba(0, 169, 209, 1)',
              pointRadius: 3,
              pointHoverRadius: 8,
              borderColor: 'rgba(0, 169, 209, 1)'
            },
            c.datasets[1],
            {
              ...c.datasets[2],
              backgroundColor: 'rgba(0, 169, 209, 1)',
              pointRadius: 3,
              pointHoverRadius: 8,
              borderColor: 'rgba(0, 169, 209, 1)'
            },
            c.datasets[3]
          ]
        }
      })
    } else {
      setChartData(c => {
        const datasetsTmp = c.datasets
        const datasetsReturn = datasetsTmp.map((dataset, idx) => {
          if (idx === 0 || idx === 2) {
            return {
              ...dataset,
              backgroundColor: 'rgba(0, 169, 209, 0)',
              pointRadius: 0,
              pointHoverRadius: 0,
              borderColor: 'rgba(0, 169, 209, 0)'
            }
          } else {
            return dataset
          }
        })
        return {
          ...c,
          datasets: datasetsReturn
        }
      })
    }
  }, [aprueboState])

  useEffect(() => {
    if (rechazoState) {
      setChartData(c => {
        return {
          ...c,
          datasets: [
            c.datasets[0],
            {
              ...c.datasets[1],
              backgroundColor: 'rgba(255, 58, 59, 1)',
              pointRadius: 3,
              pointHoverRadius: 8,
              borderColor: 'rgba(255, 58, 59, 1)'
            },
            c.datasets[2],
            {
              ...c.datasets[3],
              backgroundColor: 'rgba(255, 58, 59, 1)',
              pointRadius: 3,
              pointHoverRadius: 8,
              borderColor: 'rgba(255, 58, 59, 1)'
            }
          ]
        }
      })
    } else {
      setChartData(c => {
        return {
          ...c,
          datasets: [
            c.datasets[0],
            {
              ...c.datasets[1],
              backgroundColor: 'rgba(255, 58, 59, 0)',
              pointRadius: 0,
              pointHoverRadius: 0,
              borderColor: 'rgba(255, 58, 59, 0)'
            },
            c.datasets[2],
            {
              ...c.datasets[3],
              backgroundColor: 'rgba(255, 58, 59, 0)',
              pointRadius: 0,
              pointHoverRadius: 0,
              borderColor: 'rgba(255, 58, 59, 0)'
            }
          ]
        }
      })
    }
  }, [rechazoState])

  // UseEffect para cambiar variables cuando grafico sea pequeño
  useEffect(() => {
    if (resizeVars === true) {
      setChartData(c => {
        return {
          ...c,
          datasets: [
            { ...c.datasets[0], pointRadius: 3, pointHoverRadius: 8 },
            { ...c.datasets[1], pointRadius: 3, pointHoverRadius: 8 },
            { ...c.datasets[2], pointRadius: 3, pointHoverRadius: 8 },
            { ...c.datasets[3], pointRadius: 3, pointHoverRadius: 8 }
          ]
        }
      })
    } else {
      setChartData(c => {
        return {
          ...c,
          datasets: [
            { ...c.datasets[0], pointRadius: 2, pointHoverRadius: 4 },
            { ...c.datasets[1], pointRadius: 2, pointHoverRadius: 4 },
            { ...c.datasets[2], pointRadius: 2, pointHoverRadius: 4 },
            { ...c.datasets[3], pointRadius: 2, pointHoverRadius: 4 }
          ]
        }
      })
    }
  }, [resizeVars])

  // UseEffect para señalar si se ha achicado o agrandado el grafico
  useEffect(() => {
    setResizeVars(prevResize => {
      if (width < 600 && prevResize === true) {
        return false
      } else if (width > 600 && prevResize === false) {
        return true
      } else {
        return prevResize
      }
    })
  }, [width])

  function handleRadio (val) {
    const dataRadios = val.map((x) => totalData.radios[x]).filter((x) => x !== undefined)
    const labelsRadio = totalData.radios['Todas las radios'].labels
    let aprueboRadios = labelsRadio.map((el) => { return { x: el, y: 0 } })
    let rechazoRadios = labelsRadio.map((el) => { return { x: el, y: 0 } })

    if (dataRadios.length >= 1) {
      const sum = (r, a) => r.map((b, i) => a[i] + b)
      aprueboRadios = dataRadios.map((radio) => radio.apruebo.map((valor) => valor.y)).reduce(sum).map(
        (value, idx) => { return { x: labelsRadio[idx], y: value } })
      rechazoRadios = dataRadios.map((radio) => radio.rechazo.map((valor) => valor.y)).reduce(sum).map(
        (value, idx) => { return { x: labelsRadio[idx], y: value } })
    }

    setChartData({
      labels: labelsRadio.slice(inicio, final),
      datasets: [
        chartData.datasets[0],
        chartData.datasets[1],
        {
          ...chartData.datasets[2],
          data: aprueboRadios.slice(inicio, final)
        },
        {
          ...chartData.datasets[3],
          data: rechazoRadios.slice(inicio, final)
        }
      ]
    }
    )

    setCurrentRadio(val)
  }

  function handleMedio (val) {
    const dataMedios = val.map((x) => totalData.medios[x]).filter((x) => x !== undefined)
    const labelsMedio = totalData.medios['Todos los medios'].labels
    let aprueboMedios = labelsMedio.map((el) => { return { x: el, y: 0 } })
    let rechazoMedios = labelsMedio.map((el) => { return { x: el, y: 0 } })
    if (dataMedios.length >= 1) {
      const sum = (r, a) => r.map((b, i) => a[i] + b)
      aprueboMedios = dataMedios.map((medio) => medio.apruebo.map((valor) => valor.y)).reduce(sum).map(
        (value, idx) => { return { x: labelsMedio[idx], y: value } })
      rechazoMedios = dataMedios.map((medio) => medio.rechazo.map((valor) => valor.y)).reduce(sum).map(
        (value, idx) => { return { x: labelsMedio[idx], y: value } })
    }

    setChartData({
      labels: labelsMedio.slice(inicio, final),
      datasets: [
        {
          ...chartData.datasets[0],
          data: aprueboMedios.slice(inicio, final)
        },
        {
          ...chartData.datasets[1],
          data: rechazoMedios.slice(inicio, final)
        },
        chartData.datasets[2],
        chartData.datasets[3]
      ]
    }
    )

    setCurrentMedio(val)
  }

  function handleDate (date, dateStr) {
    let inicioTmp = 0
    let finalTmp = totalData.medios['Todos los medios'].labels.length

    if (dateStr[0] !== '') {
      if (date[0]._d.getFullYear() === 2022) {
        const startDateIn = new Date(date[0]._d.getFullYear(), 0, 1)
        const daysIn = Math.floor(
          (date[0]._d - startDateIn) / (24 * 60 * 60 * 1000)
        )
        const weekNumberIn = Math.ceil(daysIn / 7)
        inicioTmp = weekNumberIn - 1
      } else {
        inicioTmp = 0
      }

      if (date[1]._d.getFullYear() === 2022) {
        const startDateFin = new Date(date[1]._d.getFullYear(), 0, 1)
        const daysFin = Math.floor(
          (date[1]._d - startDateFin) / (24 * 60 * 60 * 1000)
        )
        const weekNumberFin = Math.ceil(daysFin / 7)
        finalTmp = weekNumberFin
      } else {
        finalTmp = totalData.medios['Todos los medios'].labels.length
      }
    }

    if (finalTmp > totalData.medios['Todos los medios'].labels.length) {
      finalTmp = totalData.medios['Todos los medios'].labels.length
    }

    if (inicioTmp > totalData.medios['Todos los medios'].labels.length) {
      inicioTmp = totalData.medios['Todos los medios'].labels.length
    }

    if (finalTmp < 0) {
      finalTmp = 0
    }

    if (inicioTmp < 0) {
      inicioTmp = 0
    }

    setInicio(inicioTmp)
    setFinal(finalTmp)

    const dataMedios = currentMedio.map((x) => totalData.medios[x]).filter((x) => x !== undefined)
    const dataRadios = currentRadio.map((x) => totalData.radios[x]).filter((x) => x !== undefined)
    const labelsMedio = totalData.medios['Todos los medios'].labels
    const labelsRadio = totalData.radios['Todas las radios'].labels
    let aprueboMedios = labelsMedio.map((el) => { return { x: el, y: 0 } })
    let rechazoMedios = labelsMedio.map((el) => { return { x: el, y: 0 } })
    let aprueboRadios = labelsRadio.map((el) => { return { x: el, y: 0 } })
    let rechazoRadios = labelsRadio.map((el) => { return { x: el, y: 0 } })
    if (dataMedios.length >= 1) {
      const sum = (r, a) => r.map((b, i) => a[i] + b)
      aprueboMedios = dataMedios.map((medio) => medio.apruebo.map((valor) => valor.y)).reduce(sum).map(
        (value, idx) => { return { x: labelsMedio[idx], y: value } })
      rechazoMedios = dataMedios.map((medio) => medio.rechazo.map((valor) => valor.y)).reduce(sum).map(
        (value, idx) => { return { x: labelsMedio[idx], y: value } })
    }

    if (dataRadios.length >= 1) {
      const sum = (r, a) => r.map((b, i) => a[i] + b)
      aprueboRadios = dataRadios.map((radio) => radio.apruebo.map((valor) => valor.y)).reduce(sum).map(
        (value, idx) => { return { x: labelsRadio[idx], y: value } })
      rechazoRadios = dataRadios.map((radio) => radio.rechazo.map((valor) => valor.y)).reduce(sum).map(
        (value, idx) => { return { x: labelsRadio[idx], y: value } })
    }

    setChartData({
      labels: labelsMedio.slice(inicioTmp, finalTmp),
      datasets: [
        {
          ...chartData.datasets[0],
          data: aprueboMedios.slice(inicioTmp, finalTmp)
        },
        {
          ...chartData.datasets[1],
          data: rechazoMedios.slice(inicioTmp, finalTmp)
        },
        {
          ...chartData.datasets[2],
          data: aprueboRadios.slice(inicioTmp, finalTmp)
        },
        {
          ...chartData.datasets[3],
          data: rechazoRadios.slice(inicioTmp, finalTmp)
        }
      ]
    }
    )
  }

  function handleLegend (e) {
    e.preventDefault()
    if (e.target.name === 'apruebo' || e.target.id === 'apruebo') {
      setAprueboState(!aprueboState)
      document.getElementById('apruebo').classList.toggle('clicked')
    }

    if (e.target.name === 'rechazo' || e.target.id === 'rechazo') {
      setRechazoState(!rechazoState)
      document.getElementById('rechazo').classList.toggle('clicked')
    }
  }

  function handleDownload (e) {
    function downloadImage (idElement) {
      const urlBase64 = document
        .getElementById(idElement)
        .toDataURL('image/png')

      const a = document.createElement('a') // Create <a>
      a.href = urlBase64 //  Image Base64 Goes here
      a.download = 'Apruebo_Rechazo.png' // File name Here
      a.click() // Downloaded file
    }

    e.preventDefault()
    downloadImage('mediosChart')
  }

  return (
    <div className="App">
      <Space direction="vertical" size={2} style={{ display: 'flex' }}>
        <Row>
          <Col xs={{ span: 20, offset: 4 }} lg={{ span: 20, offset: 2 }}>
            <PlotMenu
              medios={medios}
              radios={radios}
              handleMedio={handleMedio}
              handleRadio={handleRadio}
              handleDate={handleDate}
              handleLegend={handleLegend}
              handleDownload={handleDownload}
              currentMedio={currentMedio}
              currentRadio={currentRadio}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={{ span: 22, offset: 1 }} lg={{ span: 21, offset: 1 }}>
            {Object.keys(options).length > 0
              ? (
              <MediosChart chartData={chartData} options={options} />
                )
              : (
              <div />
                )}
          </Col>
        </Row>
      </Space>
    </div>
  )
}

export default App
